import { isNetherUndefinedNorNull } from '@app/utils/validationUtils';

export const shortenStr = (str: string | number, expectedLength?: number, firstIndex = 0) => {
    if (isNetherUndefinedNorNull(expectedLength)) {
        return str.toString().substring(firstIndex, expectedLength);
    }
    return str;
};

export const isEmptyString = (str: string) => {
    return str.length === 0;
};

export const toMidDottedStr = (str: string | number, leadingVisible = 12, firstIndex = 0) => {
    if (!str) return str;
    const total = str.toString().length;
    if (total <= leadingVisible * 2) return str;
    const leadingStr = str.toString().substring(firstIndex, leadingVisible);
    const trailingStr = str.toString().substring(total - leadingVisible);
    return `${leadingStr}...${trailingStr}`;
};

export const toEndDottedStr = (str: string | number, leadingVisible = 12, firstIndex = 0) => {
    if (!str) return '';
    if (str.toString().length <= leadingVisible) return str.toString();
    const leadingStr = str.toString().substring(firstIndex, leadingVisible);
    return `${leadingStr}...`;
};

export const capitalize = (val: { toString: () => string }): string => {
    if (!val) return '';
    const firstChar = val.toString()[0]?.toUpperCase();
    return `${firstChar}${val.toString().substring(1).toLowerCase()}`;
};

export const ellipsesText = (text: string, limit: number) => {
    let descStripped = text;
    if (text.length > limit) {
        descStripped = toEndDottedStr(text, limit);
    }

    return descStripped.replace(/\\n/gi, '\n');
};

export const trimTooltipTitle = (title?: string, limit: number = 20) => {
    if (title && title.length > limit) return title;
    return '';
};

export const getLastItem = (arr: string) => {
    return arr.charAt(arr.length - 1);
};

/** Turns a `YYYY-MM` content date into a display string like "Aug 2025". */
export const formatMonth = (value: string) => {
    const [year, month] = value.split('-');
    const monthIndex = Number(month) - 1;
    if (!year || Number.isNaN(monthIndex) || monthIndex < 0 || monthIndex > 11) return value;
    const label = new Date(Date.UTC(Number(year), monthIndex, 1)).toLocaleString('en-US', { month: 'short', timeZone: 'UTC' });
    return `${label} ${year}`;
};

/** `YYYY-MM-DD` to a grouping key like "September 2026", for diary month headings. */
export const monthKey = (value: string) => {
    const [year, month] = value.split('-');
    const monthIndex = Number(month) - 1;
    if (!year || Number.isNaN(monthIndex) || monthIndex < 0 || monthIndex > 11) return value;
    const name = new Date(Date.UTC(Number(year), monthIndex, 1)).toLocaleString('en-GB', { month: 'long', timeZone: 'UTC' });
    return `${name} ${year}`;
};

/** `YYYY-MM-DD` to "6 September". Falls back to the month for older entries. */
export const formatDiaryDate = (value: string) => {
    const [year, month, day] = value.split('-');
    const monthIndex = Number(month) - 1;
    if (!year || Number.isNaN(monthIndex) || monthIndex < 0 || monthIndex > 11) return value;
    const monthName = new Date(Date.UTC(Number(year), monthIndex, 1)).toLocaleString('en-GB', { month: 'long', timeZone: 'UTC' });
    return day ? `${Number(day)} ${monthName}` : `${monthName} ${year}`;
};

/** The year on its own, for the divider at the top of a run of entries. */
export const yearOf = (value: string) => value.split('-')[0];
